import Request from '@/plugins/request';

export function getPrinterDevices(params) {
  return Request.get('printer-devices', { params })
}

export function createPrinterDevice() {
  return Request.get(`printer-devices/create`)
}

export function storePrinterDevice(data) {
  return Request.post('printer-devices', data)
}

export function updatePrinterDevice(id, data) {
  return Request.put(`printer-devices/${id}`, data)
}

export function editPrinterDevice(id) {
  return Request.get(`printer-devices/${id}/edit`)
}

export function destroyPrinterDevice(id) {
  return Request.delete(`printer-devices/${id}`)
}
